import styled from 'styled-components';

export const NavWrapper = styled.div`
  @media ${({ theme }) => theme.media.mobile} {
    display: none;
  }

  @media ${({ theme }) => theme.media.tablet} {
    /* display: none; */
    align-items: center;
    justify-content: space-space-around;
  }
  @media ${({ theme }) => theme.media.laptop} {
    display: flex;
  }
`;

export const NavSite = styled.h3`
  @media ${({ theme }) => theme.media.tablet} {
    font-size: ${({ theme }) => theme.fontSize.m};
    font-weight: 100;
    margin: 20px;
    text-align: center;
  }
`;
